import { TFunction } from "i18next";
import * as Yup from "yup";

export const getExtraFieldFormSchema = (t: TFunction) => {
    return Yup.object().shape({
        fieldName: Yup.string().trim().required(t("common:form.requiredFieldForm")),
        objectType: Yup.number()
            .required(t("common:form.requiredFieldForm"))
            .typeError(t("common:form.invalidNumberForm")),
        description: Yup.string().trim().required(t("common:form.requiredFieldForm")),
        orderInHistorical: Yup.number()
            .nullable()
            .transform((value, originalValue) => originalValue === "" ? null : value)
            .min(1, t("common:form.invalidNumberForm"))
            .when("showInHistorical", {
                is: true,
                then: (schema) => schema.required(t("common:form.requiredFieldForm")),
                otherwise: (schema) => schema.notRequired(),
            }),
        historicalColumnName: Yup.string()
            .trim()
            .nullable()
            .when("showInHistorical", {
                is: true,
                then: (schema) => schema.required(t("common:form.requiredFieldForm")),
                otherwise: (schema) => schema.notRequired(),
            }),
    });
};

